import { createFaasProcedureConfig } from '@americanexpress/iguazu-procedures/utils/createFaasProcedureConfig';

// https://explorer.aexp.com/functions/ReadCustomerProductDetails.v1
export default createFaasProcedureConfig(
  'ReadCustomerProductDetails.v1'
);
